class ListService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  get(params) {
    return this.apiService.get('/api/v1/lists', params);
  }

  getById(id) {
    return this.apiService.get(`/api/v1/lists/${id}`);
  }

  getItemsById(id, params) {
    return this.apiService.get(`/api/v1/lists/${id}/items`, params);
  }

  removeItem(id, itemId) {
    return this.apiService.delete(`/api/v1/lists/${id}/items/${itemId}`);
  }

  removeAllItems(id, itemId) {
    return this.apiService.delete(`/api/v1/lists/${id}/items`);
  }

  createItem(id, params) {
    return this.apiService.post(`/api/v1/lists/${id}/items`, params);
  }

  updateItem(id, itemId, params) {
    return this.apiService.put(`/api/v1/lists/${id}/items/${itemId}`, params);
  }

  remove(id, itemId) {
    return this.apiService.delete(`/api/v1/lists/${id}`);
  }

  create(params) {
    return this.apiService.post(`/api/v1/lists`, params);
  }

  update(params) {
    return this.apiService.put(`/api/v1/lists/${params.id}`, params);
  }
}

export default ListService;
